import React, { useEffect, useState } from 'react';
import { Select } from 'antd';
import { CoordProfService } from '../Services/CoordProfService';

const CategoriesPro = ({ type, onChange, value }) => {
  const [options, setOptions] = useState([]);
  const coordProfService = new CoordProfService();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await coordProfService.getAllCoordProf();
        const filteredOptions = data.filter(option => option.type === type);
        setOptions(filteredOptions);
      } catch (error) {
        console.error('Erreur lors de la récupération des catégories professionnelles :', error);
      }
    };

    fetchData();
  }, [type]);

  return (
    <Select onChange={onChange} value={value}>
      {options.map(option => (
        <Select.Option key={option.code} value={option.code}>
          {option.libelle}
        </Select.Option>
      ))}
    </Select>
  );
};

export default CategoriesPro;
